/***
 **Module Name: recommend
 **File Name :  recommend.js
 **Project :    Orasi Media
 **Copyright(c) : X Platform Consulting.
 **Organization : Peafowl Inc
 **author :  chandrasekhar
 **author :  Hari
 **license :
 **version :  1.0.0
 **Created on :
 **Created on: Dec 29 2022
 **Last modified on: Dec 29 2022
 **Description : contains recommend table details.
 ***/
import React, { useState, useEffect, useContext } from "react";
import Footer from "../../../components/dashboard/footer";
import Header from "../../../components/dashboard/header";
import Sidebar from "../../../components/dashboard/sidebar";
import tmdbApi from "../../../api/tmdbApi";
import { useNavigate, Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import axios from "axios";
import moment from "moment";
import ViewRecommendList from "./viewRecommend";
import { contentContext } from "../../../context/contentContext";
import SessionPopup from "../../SessionPopup"
import Loader from "../../../components/loader";
import TableLoader from "../../../components/tableLoader";
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

let { appname, lambda } = window.app;

const Recommend = () => {
  const navigate = useNavigate();
  // const [toggle, setToggle] = useState(false);
  const [content, setContent] = useState("");
  const [perpage, setPerpage] = useState(10);

  // const [data, setData] = useState([]);
  const [tableErrMsg, setTableErrMsg] = useState(false);

  const [currentPage, setcurrentPage] = useState(1);

  const [itemsPerPage, setitemsPerPage] = useState(10);

  const [pageNumberLimit, setpageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);

  const [recommendedsearch, setRecommendedSearch] = useState("");
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);

  const [sortDirection, setSortDirection] = useState('asc');
  const [arrowdir, setArrowDir] = useState('down');
  const [num, setNum]= useState();

    

  const [viewRecommend, setViewRecommend] = useState({});
  const [click, setClick] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  // var global.exportExcelData = []
  const { isLoading, setIsLoading, sortTableAlpha, arrow, sortTableByDate, userData, data, setData,rowsPerPage, setRowsPerPage,currentPageNew, setCurrentPage,route, setRoute,usePrevious, setActiveMenuId ,setActiveMenuObj, GetTimeActivity} = useContext(contentContext)


  const validateObj = userData && userData.permissions && userData.permissions.length > 0 && userData.permissions.filter(eachItem => eachItem.menu == "Reports")
  const subValDashboard = validateObj && validateObj[0] && validateObj[0].submenus && validateObj[0].submenus[1] && validateObj[0].submenus[1].dashboard
  // console.log('subValDashboard obj',subValDashboard)

  const prevRoute = usePrevious(route)
  useEffect(() => {
      if(prevRoute != undefined && prevRoute!=route){
          setCurrentPage(1)
          setRowsPerPage(15)
      }
  }, [prevRoute]);
 //  console.log('prevRoute--->',prevRoute)
 //  console.log('currentRoute--->',route)
 const keyForRerender = `${rowsPerPage}_${data?.length}`;
  const columns = [

      {
          name: 'Client Name',
          selector: row => row?.clientname ?? "",
          sortable: true,
      },
      {
          name: 'Client Email',
          selector: row => row?.clientemailid ?? "",
          sortable: true,
      },
      {
          name: 'RECOMMEND TO',
          selector: row => row?.name ?? "",
          sortable: true,
      },
      { 
          name: 'RECOMMEND EMAIL',
          selector: row =>  row?.emailid ?? "",
          sortable: true,
      },
      {
         name: 'CONTACT NUMBER',
         selector: row => row?.contact ?? "",
         sortable: true,
     },
     {
      name: 'RECOMMENDED ON',
      // selector: row => moment(row.created).utc().format("DD-MMM-YYYY"),
      selector: row => row?.created,
      cell: (props) =>   props.created != undefined ?  new Date(props.created).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }) :'',
    sortable: true,
      // sortFunction: (a, b) => moment(a.created).diff(b.created),
  },
     

     

      {
          name: <>{subValDashboard && subValDashboard.view && subValDashboard.view.display === true && 'Actions'}</>,
          cell: (props) => 
         //   {
          subValDashboard && subValDashboard.view && subValDashboard.view.display === true &&
         <div className="d-flex">
         <a
           className={`${subValDashboard && subValDashboard.view && subValDashboard.view.enable === false ? 'pe-none' : ''} text-success action-button`}
           onClick={(e) => handleRecommendView(e, props.recommendedid)}
         >
           <i className="mdi mdi-eye font-size-18"></i>
         </a>
       </div>
         //  }
          ,
          ignoreRowClick: true,
          allowOverflow: true,
          button: true,
      },
  ];

  const handlePageChange = (page) => {
    GetTimeActivity()   
      setCurrentPage(page);
    };
  
    const handlePerRowsChange = (newPerPage) => {
      GetTimeActivity()   
      setRowsPerPage(newPerPage);
    };
   
 


  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/");
    }
    setRoute("recommend")
    setActiveMenuId(300051)
    setActiveMenuObj({
        "Client Management": false,
        "Contact Management": false,
        "Reports": true
    })
    getRecommend();
    userActivity();
  }, []);
  const userActivity = () => {

    let path = window.location.pathname.split("/");
    const pageName = path[path.length - 1];
    var presentTime = moment();
    let payload;

    payload = {
        "userid": localStorage.getItem("userId"),
        "pagename": pageName,
        "pageurl": window.location.href,
        "starttime": presentTime,
        "useragent": JSON.parse(localStorage.getItem("loc"))

    };


  
    const previousId = localStorage.getItem("previousid");
    const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");
    
    axios({
        method: 'POST',
        url: urlLink,
        data: payload
    })
        .then(function (response) {
            if (response?.data?.statusCode === 200) {
                localStorage.setItem("previousid", response?.data?.result)
            }
        });
}
  const getRecommend = async (e) => {
    GetTimeActivity()   
    setIsLoading(true)
    const token = localStorage.getItem("token")
    axios({
      method: "POST",
      url:
        lambda +
        "/recommend?appname=" +
        appname + "&token=" + token + "&userid=" + localStorage.getItem("userId"),
    }).then(function (response) {
      console.log("response", response?.data?.result?.data);
      if (response?.data?.result == "Invalid token or Expired") {
        setShowSessionPopupup(true)
      } else {
        setData(response?.data?.result?.data);
          

        global.exportExcelData = response?.data?.result?.data
        setContent(response?.data?.result);
        setIsLoading(false)
        setRecommendedSearch("")
      }
    }).catch((err) => {
      console.log('error', err);
      setTableErrMsg(true)
      setIsLoading(false);
  });
  };





  const handleSearch = () => {
    GetTimeActivity()   
    setCurrentPage(1);

    if (recommendedsearch === "") {
      getRecommend();
    } else {
      setIsLoading(true)
      const token = localStorage.getItem("token")
      axios({
        method: "POST",
        url:
          lambda +
          "/recommend?appname=" +
          appname +
          "&search=" +
          recommendedsearch + "&token=" + token + "&userid=" + localStorage.getItem("userId"),
      }).then(function (response) {
        console.log("res", response)
         if (response?.data?.result == "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          console.log("response", response);
          setData(response?.data?.result?.data);
          global.exportExcelData = response?.data?.result?.data
            

          setContent(response?.data?.result);
          setIsLoading(false)
        }
      }).catch((err) => {
        console.log('error', err);
        setTableErrMsg(true)
        setIsLoading(false);
    });
    }
  };

  const handleChange = (e) => {
    if (e.target.value === "") {
      //getRecommend();
    }
    setRecommendedSearch(e.target.value);
  };

  const handleKeypress = (e) => {
    //it triggers by pressing the enter key
    GetTimeActivity()   
    if (e.key === "Enter") {
      setTimeout(function () {
        handleSearch();
      }, 1000);
    }
  };

  const handleRecommendView = (e, id) => {
    GetTimeActivity()   
    for (let key in data) {
      
      if (data.hasOwnProperty(key) && data[key].recommendedid === id) {
        console.log("data id", id);
        setViewRecommend(data[key]);
        setClick(true);

      }
    }
  };

  const clearSearch = () => {
    GetTimeActivity()   
    setRecommendedSearch("");
    getRecommend();
    setcurrentPage(1);
  }
  const customNoRecords = () => {
    return(
        
        <div className="empty-state-body empty-record"  >
            <div className="empty-state__message">
                <span className="material-icons">summarize</span>
                <p className="form-check font-size-16">No names or emails were found with the searched keyword</p>
            </div> </div>
    )
} 
// console.log('datataatatatta',data)

const handleExport = () => {
      // let k = defaultData || global.exportExcelData
      const modifiedArray = global.exportExcelData.map((each,i) => ({
      "S.NO":i+1,
      "CLIENT NAME": each?.clientname ?? "",
      "CLIENT EMAIL": each?.clientemailid ?? "",
      "RECOMMEND TO": each?.name ?? "",
      "RECOMMEND EMAIL": each?.emailid ?? "",
      "CONTACT NUMBER": each?.contact ?? "",
      "RECOMMENDED ON": each?.created ? new Date(each?.created).toLocaleDateString('en-IN', {
        day: 'numeric',
        month: 'short', 
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
       
    }) :"",
    }));
    // console.log('data2 after',data2)

    exportToExcel(modifiedArray, "data");

}
function exportToExcel(jsonData, fileName) {
    delete jsonData['_id'];
    const worksheet = XLSX.utils.json_to_sheet(jsonData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
    //FileSaver.saveAs(data, `${fileName}.xlsx`);
    FileSaver.saveAs(data, `RecommendedData.xlsx`);
}

const customSort = (rows, selector, direction) => {
  const sortedData = rows.slice().sort((rowA, rowB) => {
    // use the selector function to resolve your field names by passing the sort comparators
    // const aField = selector(rowA);
        const aField = String(selector(rowA)).toLowerCase();

    //  const bField = selector(rowB);
          const bField = String(selector(rowB)).toLowerCase();

    let comparison = 0;

    if (aField > bField) {
      comparison = 1;
    } else if (aField < bField) {
      comparison = -1;
    }

    return direction === 'desc' ? comparison * -1 : comparison;
  });

  // Log the sorted data to the console
  // setSortedRecomData(sortedData)
  global.exportExcelData = sortedData
  // console.log('Sorted Data------>:', sortedData);

  return sortedData;
};

  // console.log("matched data-sampleData-------->", global.exportExcelData);
  return (
    <>
      {showSessionPopupup && <SessionPopup />}
      <div id="layout-wrapper">
        <Header />
        <Sidebar />
        { click ? (<ViewRecommendList data={viewRecommend} click={click} setClick={setClick} />) :
            <div className="main-content user-management clients clients-search recommeded">
              <div className="page-content">
                <div className="container-fluid">
                  <div className="row mb-4 breadcrumb">
                    <div className="col-lg-12">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h4 className="mb-2 card-title">Recommended Data</h4>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row table-data">
                    <div className="col-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="row mb-2">
                          <div className="col-sm-4 button-block">
                                                <div className="dataTables_length" id="datatable_length">
                                                                         <button className={`fill_btn ${data.length <= 0 ?'disable pe-none':''}`} onClick={handleExport}><span className="material-icons">north_east</span>Export</button>
                                                                     </div>
                                                </div>
                            <div className="col-sm-8">
                              <div className="search-box mb-2 d-inline-block">
                                <div className="position-relative">
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Name"
                                    value={recommendedsearch}
                                    onChange={(e) => handleChange(e)}
                                    onKeyPress={handleKeypress}
                                  />
                                  {/* <input className="form-control u-calendar" name="availableFrom" type="date" placeholder="Release Date" max="2023-03-15" value="" />
                                                             <input className="form-control u-calendar" name="availableFrom" type="date" placeholder="Release Date" max="2023-03-15" value="" /> */}
                                  <button className="fill_btn" onClick={handleSearch}>
                                    <span
                                      className="material-icons search-icon"
                                    
                                    >
                                      search
                                    </span>
                                  </button>
                                </div>
                                <div className="dataTables_length" id="datatable_length">
                                  <button className="fill_btn" onClick={clearSearch}><span className="material-icons-outlined">sync</span>Reset</button>
                                </div>
                               
                              </div>
                              <div className="text-sm-end"></div>
                            </div>
                          </div>

                            < DataTable  key={keyForRerender}
                                                 // title=""
                                                 columns={columns}
                                                 // className="table align-middle table-nowrap table-check"
                                                 keyField='_id'
                                                 data={data || []} 
                                                 direction="auto"
                                                 highlightOnHover
                                                 fixedHeaderScrollHeight="300px"
                                                 pagination
                                                 responsive
                                                 persistTableHead
                                                 // selectableRowsVisibleOnly
                                                 striped
                                                 // selectableRowsHighlight
                                                 // selectableRows
                                                 subHeaderAlign="right"
                                                 defaultSortField="name"
                                                 subHeaderWra
                                                 noDataComponent={customNoRecords()}
                                                 paginationTotalRows={data.length}
                                                 onChangeRowsPerPage={handlePerRowsChange}
                                                 onChangePage={handlePageChange}
                                                 paginationPerPage={rowsPerPage}
                                                 paginationDefaultPage={currentPageNew}
                                                paginationRowsPerPageOptions={[15,25,50,75,100]}
                                                // onSort={handleSort}
                                                sortFunction={customSort}
                                                paginationComponentOptions={{
                                                     rowsPerPageText: 'Per page:',
                                                     rangeSeparatorText: 'of',
                                                     noRowsPerPage: false,
                                                     selectAllRowsItem: false,
                                                     selectAllRowsItemText: 'All',
                                                   }}
                                           
                                                 progressPending={isLoading}
                                                 progressComponent={<TableLoader />}
                                                   />
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
              <SweetAlert show={tableErrMsg}
                         custom
                         confirmBtnText="ok"
                         confirmBtnBsStyle="primary"
                         title={"Something went wrong. Please reload again."}
                         onConfirm={e => setTableErrMsg(false)}
                     >
                     </SweetAlert>
              <Footer />
            
            </div>
        }
      </div>
    </>
  );
};

export default Recommend;
